/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".webcam-wrapper[_ngcontent-%COMP%]   video[_ngcontent-%COMP%]{position:absolute;top:50%;left:0;transform:translate(0,-50%);width:100%;height:auto}.webcam-wrapper[_ngcontent-%COMP%]   canvas[_ngcontent-%COMP%]{opacity:0}"];
export { styles as styles };
